(() => {
  const init = () => {
    if (!document.querySelector('.el-home')) return;
    document.documentElement.classList.add('home-motion-ready');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = Array.from(document.querySelectorAll('[data-el-reveal]'));
    const counters = Array.from(document.querySelectorAll('[data-el-count]'));

    if ('IntersectionObserver' in window && !reduceMotion) {
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
      reveals.forEach((item) => revealObserver.observe(item));

      const counterObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const element = entry.target;
          const target = Number(element.dataset.elCount || '0');
          const prefix = element.dataset.elPrefix || '';
          const suffix = element.dataset.elSuffix || '';
          const start = performance.now();
          const duration = 1000;
          const tick = (now) => {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            element.textContent = prefix + Math.round(target * eased) + suffix;
            if (progress < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
          counterObserver.unobserve(element);
        });
      }, { threshold: 0.5 });
      counters.forEach((item) => counterObserver.observe(item));
    } else {
      reveals.forEach((item) => item.classList.add('is-visible'));
    }

    document.querySelectorAll('[data-el-hero]').forEach((root) => {
      if (root.dataset.elReady === 'true') return;
      root.dataset.elReady = 'true';
      const video = root.querySelector('video');
      const button = root.querySelector('[data-el-video-toggle]');
      if (!video || !button) return;
      const update = () => {
        const playing = !video.paused;
        button.setAttribute('aria-label', playing ? 'Pause hero video' : 'Play hero video');
        button.setAttribute('aria-pressed', String(!playing));
        button.textContent = playing ? 'Pause' : 'Play';
      };
      if (reduceMotion) video.pause();
      update();
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
        window.setTimeout(update, 0);
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
